import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UserDetail } from './types/user-detail.type';

/**
 * Fetches a single user, including the roles and direct permission grants assigned to them.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the user.
 * @returns OperationResultWithData wrapping `UserDetail`.
 */
export const getUser = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.get<OperationResultWithData<UserDetail>>(formatString(Uri.users.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
